
// import keyMirror from 'fbjs/lib/keyMirror';
import keyMirror from 'keymirror';

export const ConfirmClearArraysModalActionTypes = keyMirror({
  OPEN_CONFIRM_CLEAR_ARRAYS_MODAL: undefined,
  HIDE_CONFIRM_CLEAR_ARRAYS_MODAL: undefined,
});
